module.exports = __webpack_public_path__ + "static/media/weather-dashboard.a5a7f07d.png";